module.exports = __webpack_public_path__ + "static/logo-0030f17b4162a2990ec93ddab74aef2a.svg";